<div class="detaljer">
  <span class="ikon">
    <mat-icon fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon"/>
  </span>
  <span class="favoritt">
    @if (erFavoritt()) {
      <mat-icon fontSet="ion-ios-star" class="mat-icon--ionic-ikon"/>
    }
  </span>
  <span class="tittel" data-testid="oppgave-tittel" #tittelFelt>{{ oppgave().tittel }}</span>
  <oppgave-status [oppgave]="oppgave()" modus="utvidet" class="status"/>
  <span class="ansvarlig" data-testid="oppgave-avatar">
    @if (oppgave().ansvarlig) {
      <avatar [medlem]="oppgave().ansvarlig" stil="liten"/>
    } @else if (oppgave().sp2Ansvarlig) {
      <avatar [navn]="oppgave().sp2Ansvarlig" stil="liten"/>
    }
  </span>
  <span class="forelder">
    @if (visForelder()) {
      <foreldersti [forelder]="forelder()" [eiendeGruppeId]="oppgave().eiendeGruppeId" stil="kort">{{ 'tilknyttet'|translate }}</foreldersti>
    }
  </span>
  <span class="meny">
    <button mat-icon-button
            [matMenuTriggerFor]="oppgaveMeny"
            (click)="$event.stopPropagation()"
            [disabled]="menyDeaktivert()"
            class="mat-medium-icon-button"
            data-testid="oppgave-meny">
      <mat-icon class="material-symbols-fet">more_vert</mat-icon>
    </button>
    <mat-menu #oppgaveMeny="matMenu">
      @if (redigeringMulig()) {
        <button mat-menu-item (click)="rediger()">
          <mat-icon>edit</mat-icon>
          {{ 'Rediger'|translate }}
        </button>
      }
      @if (redigeringMulig() || oppgave().ansvarlig?.brukerId == bruker().id) {
        <button mat-menu-item (click)="inverterUtfoertStatus()">
          <mat-icon fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon"/>
          @if (oppgave().utfoert) {
            {{ 'Sett ikke-utført'|translate }}
          } @else {
            {{ 'Sett utført'|translate }}
          }
        </button>
      }
      @if (redigeringMulig()) {
        <button mat-menu-item (klikk)="slett()" [bekreftKlikk]="'Ja, slett oppgaven'|translate">
          <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/>
          {{ 'Slett'|translate }}
        </button>
      }
      <button mat-menu-item (click)="endreFavorittmarkering()">
        <mat-icon fontSet="ion-ios-star-outline" class="mat-icon--ionic-ikon"/>
        @if (erFavoritt()) {
          {{ 'Fjern fra favorittlisten'|translate }}
        } @else {
          {{ 'Legg til i favorittlisten'|translate }}
        }
      </button>
    </mat-menu>
  </span>
</div>
<div class="beskrivelse" data-testid="oppgave-beskrivelse">
  <html-formatert [innhold]="oppgave().beskrivelse"/>
</div>
<div class="kommentarer ikke-print">
  <div (click)="this.erVisKommentarer.set(!this.erVisKommentarer())" class="vis-skjul" data-testid="togle-kommentarer">
    <span>
      @if (!erVisKommentarer()) {
        <mat-icon fontSet="ion-ios-arrow-right" class="mat-icon--ionic-ikon" inline="true"/>
        {{ 'Vis'|translate }}
      } @else {
        <mat-icon fontSet="ion-ios-arrow-down" class="mat-icon--ionic-ikon" inline="true"/>
        {{ 'Skjul'|translate }}
      }
      <kommentarer-teller [forelder]="oppgave().id"/>
    </span>
    <mat-icon fontSet="ion-ios-chatbubble-outline" class="mat-icon--ionic-ikon" inline="true"/>
  </div>

  @if (erVisKommentarer()) {
    <oppgave-kommentarer [oppgave]="oppgave()"/>
  }
</div>
<liste-lenkerelasjoner [lenker]="oppgave().referertFra"/>
